import axios, { AxiosError } from 'axios';
import { toast } from 'react-hot-toast';
import { removeToken } from 'src/store/token/tokenSlice';
import { removeUser } from 'src/store/user/userSlice';
import { store } from 'src/store';
import { loadState } from '../utils/browser-storage';

let isRedirecting = false;

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  paramsSerializer: {
    indexes: null
  }
});

api.interceptors.request.use(
  (config) => {
    const token = loadState<string>('token');
    if (token && config.headers && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (err: AxiosError) => Promise.reject(err)
);

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const status = error.response?.status;

    if (String(error.code).toUpperCase() === 'ECONNABORTED') {
      toast.error('Request timeout, silahkan coba lagi');
    } else if (status === 401 && !isRedirecting) {
      isRedirecting = true;
      store.dispatch(removeToken());
      store.dispatch(removeUser());
      toast.error('Sesi telah berakhir, silahkan login kembali');
      setTimeout(() => {
        window.location.href = '/auth/login';
      }, 500);
    } else if (status === 500) {
      toast.error('Internal Server Error');
    } else if (status === 502) {
      toast.error('Bad Gateway, silahkan coba beberapa saat lagi');
    } else {
      const message =
        (error.response?.data as any)?.errorCodes?.[0] ??
        (error.response?.data as any)?.message ??
        error.message ??
        'Terjadi kesalahan';
      toast.error(message);
      // console.log(error.response?.data);
    }

    return Promise.reject(error);
  }
);

export default api;
